import { Component, OnInit, AfterContentChecked } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { isGeneral2 } from '../../shared/services';
import { StoreHelper } from '../../shared/helpers/store.helper';
import { ControllerService } from '../../shared/services/controller.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, AfterContentChecked {
  authenticated = false;
  hrUser = false;
  HRview = false;
  normalUser = true;
  isWelcomeOption = null;
  superUser = false
  isEducation = false

  haveIncompleteTraining = false
  isInLibrary = false
  showReportsMenu = false
  menuTimeout: any
  isMenuOpen = false;

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  toggleReportsMenu(event: MouseEvent) {
    event.stopPropagation();
    clearTimeout(this.menuTimeout);
    this.showReportsMenu = !this.showReportsMenu;
  }

  closeReportsMenu() {
    this.showReportsMenu = false;
  }

  onReportsMouseEnter() {
    clearTimeout(this.menuTimeout);
  }

  onReportsMouseLeave() {
    this.menuTimeout = setTimeout(() => {
      this.showReportsMenu = false;
    }, 250);
  }

  constructor(private authService: AuthService, private controller: ControllerService, public router: Router) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isWelcomeOption = window.location.pathname === '/welcome' || window.location.pathname === '/science';
      }
    });
  }

  isWelcome() {
    this.isWelcomeOption = !isGeneral2() && (window.location.pathname === '/welcome' || window.location.pathname === '/science')
  }

  isHRview() {
    this.HRview = window.location.pathname.indexOf('/client/') > -1;
  }

  returnToTraining() {
    this.router.navigate(['/start'])
  }

  trainingPreview() {
    this.controller.shiftContainerToTop();
    this.router.navigate(['preview/training'])
    return false
  }

  updateAuthentication() {
    this.authenticated = this.authService.isAuthenticated();
  }

  hrView() {
    const clientName = StoreHelper.getCurrentUser().client_name
    this.controller.shiftContainerToTop()
    this.controller.setPreviewing(false)
    this.router.navigate([`client/${clientName}/report`]);
    return false;
  }

  isHrUser() {
    this.hrUser = this.authService.isAuthenticatedHr() ? true : false;
  }

  isNormalUser() {
    return true
  }

  ngOnInit() {
    this.updateAuthentication();
    this.isHrUser();
    this.isNormalUser();
    this.isWelcome();
    this.isHRview();

    this.superUser = this.authService.isSuper()
    this.isEducation = this.authService.isEducation()

  }

  ngAfterContentChecked() {
    this.updateAuthentication();
    this.isHrUser();
    this.isWelcome();
    this.isHRview();
    this.isEducation = this.authService.isEducation()
    this.superUser = this.authService.isSuper()

    this.isInLibrary = this.controller.isLibrary()
    this.haveIncompleteTraining = this.controller.getHaveIncompleteTraining()
  }

  isRouteActive(route: string, exact: boolean = false): boolean {
    return this.router.isActive(route, exact);
  }

  gotoClient() {
    this.router.navigate(['client'])
  }

  gotoCodes() {
    this.router.navigate(['code/all'])
  }

  gotoTemplates() {
    this.router.navigate(['template/all'])
  }

  gotoContent() {
    this.router.navigate(['content/all'])
  }

  gotoUsers() {
    this.router.navigate(['client/_ALL_/user'])
  }

  gotoQuestions() {
    this.router.navigate(['feedback-questions'])
  }

  gotoTags() {
    this.router.navigate(['tags'])
  }

  fullClientReport() {
    this.closeReportsMenu()
    this.router.navigate(['client/_ALL_/report'])
  }

  fullActionsReport() {
    this.closeReportsMenu()
    this.router.navigate(['client/_ALL_/actions'])
  }

  monitorReport() {
    this.closeReportsMenu()
    this.router.navigate(['monitor'])
  }

  gotoReflections(clientId) {
    this.closeReportsMenu()
    this.router.navigate(['/shared-reflections/'], { queryParams: { clientId } })
  }

  adhocReport() {
    this.closeReportsMenu()
    this.router.navigate(['/adhoc-report'])
  }

  onLogout() {
    this.controller.setPreviewing(false)
    this.authService.logout().subscribe({
      complete: () => this.router.navigate(['/signin']),
      error: () => this.router.navigate(['/signin'])
    })
    return false
  }
}
